window.blueExpressData = {
  "Antofagasta": {
    "Antofagasta": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ANF"
    },
    "Calama": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CJC"
    },
    "María Elena": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "MAE"
    },
    "Mejillones": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "MJS"
    },
    "Ollagüe": {
      "tiempo_entrega": "Entrega en 6 días hábiles",
      "codigo": "OLL"
    },
    "San Pedro de Atacama": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SPX"
    },
    "Sierra Gorda": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "SGD"
    },
    "Taltal": {
      "tiempo_entrega": "Entrega en 7 días hábiles",
      "codigo": "TTL"
    }
  },
  "Arica y Parinacota": {
    "Arica": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ARI"
    },
    "Camarones": {
      "tiempo_entrega": "Entrega en 6 días hábiles",
      "codigo": "CAM"
    },
    "General Lagos": {
      "tiempo_entrega": "Entrega en 7 días hábiles",
      "codigo": "LGR"
    },
    "Putre": {
      "tiempo_entrega": "Entrega en 7 días hábiles",
      "codigo": "PTR"
    }
  },
  "Atacama": {
    "Alto del Carmen": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ADC"
    },
    "Caldera": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CLR"
    },
    "Chañaral": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "CHN"
    },
    "Copiapó": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CPO"
    },
    "Diego de Almagro": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "DAG"
    },
    "Freirina": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "FRN"
    },
    "Huasco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "HCO"
    },
    "Tierra Amarilla": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TRM"
    },
    "Vallenar": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "VAL"
    }
  },
  "Aysén": {
    "Aysén": {
      "tiempo_entrega": "Entrega en 11 días hábiles",
      "codigo": "WPA"
    },
    "Chile Chico": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "CCH"
    },
    "Cisnes": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "CNS"
    },
    "Cochrane": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "CCL"
    },
    "Coyhaique": {
      "tiempo_entrega": "Entrega en 10 días hábiles",
      "codigo": "GXQ"
    },
    "Guaitecas": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "GCA"
    },
    "Lago Verde": {
      "tiempo_entrega": "Entrega en 12 días hábiles",
      "codigo": "LVE"
    },
    "Río Ibáñez": {
      "tiempo_entrega": "Entrega en 12 días hábiles",
      "codigo": "RIB"
    },
    "Tortel": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "TRT"
    }
  },
  "Biobío": {
    "Alto Biobío": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "AOO"
    },
    "Antuco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ANT"
    },
    "Arauco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ARA"
    },
    "Cabrero": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CRO"
    },
    "Cañete": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CTE"
    },
    "Chiguayante": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CYE"
    },
    "Concepción": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CCP"
    },
    "Contulmo": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CTU"
    },
    "Coronel": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CRN"
    },
    "Curanilahue": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ZHE"
    },
    "Florida": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "FLO"
    },
    "Hualpén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "HLP"
    },
    "Hualqui": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "HLQ"
    },
    "Laja": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LLJ"
    },
    "Lebu": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ZLB"
    },
    "Los Álamos": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "LAL"
    },
    "Los Ángeles": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "LSQ"
    },
    "Lota": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LOT"
    },
    "Mulchén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MUL"
    },
    "Nacimiento": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NAC"
    },
    "Negrete": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NRE"
    },
    "Penco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PCO"
    },
    "Quilaco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QCO"
    },
    "Quilleco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QLO"
    },
    "San Pedro de la Paz": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "SPP"
    },
    "San Rosendo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SRO"
    },
    "Santa Bárbara": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SBB"
    },
    "Santa Juana": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SJN"
    },
    "Talcahuano": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZTO"
    },
    "Tirúa": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "TUA"
    },
    "Tomé": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TMC"
    },
    "Tucapel": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TCP"
    },
    "Yumbel": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZYU"
    }
  },
  "Coquimbo": {
    "Andacollo": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ACO"
    },
    "Canela": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CNE"
    },
    "Combarbalá": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "COB"
    },
    "Coquimbo": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "COQ"
    },
    "Illapel": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ILL"
    },
    "La Higuera": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LHC"
    },
    "La Serena": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "LSC"
    },
    "Los Vilos": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LVL"
    },
    "Monte Patria": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "MPC"
    },
    "Ovalle": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "OVL"
    },
    "Paiguano": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PHO"
    },
    "Punitaqui": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PTQ"
    },
    "Río Hurtado": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "RHU"
    },
    "Salamanca": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "SCA"
    },
    "Vicuña": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VCA"
    }
  },
  "La Araucanía": {
    "Angol": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZOL"
    },
    "Carahue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CRH"
    },
    "Cholchol": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CHL"
    },
    "Collipulli": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CPI"
    },
    "Cunco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NCO"
    },
    "Curacautín": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CCC"
    },
    "Curarrehue": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "RRH"
    },
    "Ercilla": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ERL"
    },
    "Freire": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "FIE"
    },
    "Galvarino": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "GAL"
    },
    "Gorbea": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "GEA"
    },
    "Lautaro": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LTR"
    },
    "Loncoche": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LOC"
    },
    "Lonquimay": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "LQY"
    },
    "Los Sauces": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "SUS"
    },
    "Lumaco": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "LUM"
    },
    "Melipeuco": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "MLP"
    },
    "Nueva Imperial": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NIP"
    },
    "Padre Las Casas": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PCS"
    },
    "Perquenco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PQO"
    },
    "Pitrufquén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PQN"
    },
    "Pucón": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZPU"
    },
    "Purén": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PUR"
    },
    "Renaico": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RNA"
    },
    "Saavedra": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZPS"
    },
    "Temuco": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZCO"
    },
    "Teodoro Schmidt": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TEO"
    },
    "Toltén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TOL"
    },
    "Traiguén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZEN"
    },
    "Victoria": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VIC"
    },
    "Vilcún": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VIL"
    },
    "Villarrica": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VRR"
    }
  },
  "Los Lagos": {
    "Ancud": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ACD"
    },
    "Calbuco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CBU"
    },
    "Castro": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CTR"
    },
    "Chaitén": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "ZCN"
    },
    "Chonchi": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZCH"
    },
    "Cochamó": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CMO"
    },
    "Curaco de Vélez": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CVL"
    },
    "Dalcahue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "DLE"
    },
    "Fresia": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "FSA"
    },
    "Frutillar": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "FRT"
    },
    "Futaleufú": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "FTF"
    },
    "Hualaihué": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "HLH"
    },
    "Llanquihue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LLQ"
    },
    "Los Muermos": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LMU"
    },
    "Maullín": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MAU"
    },
    "Osorno": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZOS"
    },
    "Palena": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "PLE"
    },
    "Puerto Montt": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "PMC"
    },
    "Puerto Octay": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PCY"
    },
    "Puerto Varas": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZPV"
    },
    "Puqueldón": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PQE"
    },
    "Purranque": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PRE"
    },
    "Puyehue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PYH"
    },
    "Queilén": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "QLE"
    },
    "Quellón": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "QLN"
    },
    "Quemchi": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QUE"
    },
    "Quinchao": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "QCH"
    },
    "Río Negro": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RNC"
    },
    "San Juan de la Costa": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SJD"
    },
    "San Pablo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SPL"
    }
  },
  "Los Ríos": {
    "Corral": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZCR"
    },
    "Futrono": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "FTR"
    },
    "La Unión": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZLU"
    },
    "Lago Ranco": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "LRO"
    },
    "Lanco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LNC"
    },
    "Los Lagos": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LAG"
    },
    "Mariquina": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MQA"
    },
    "Máfil": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MFL"
    },
    "Paillaco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PAI"
    },
    "Panguipulli": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PGP"
    },
    "Río Bueno": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RBN"
    },
    "Valdivia": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZAL"
    }
  },
  "Magallanes": {
    "Antártica": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "ATC"
    },
    "Cabo de Hornos": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "HOR"
    },
    "Laguna Blanca": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "LBL"
    },
    "Natales": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "PNT"
    },
    "Primavera": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "PRI"
    },
    "Punta Arenas": {
      "tiempo_entrega": "Entrega en 12 días hábiles",
      "codigo": "PUQ"
    },
    "Río Verde": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "RVE"
    },
    "San Gregorio": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "SGG"
    },
    "Timaukel": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "PTI"
    },
    "Torres del Paine": {
      "tiempo_entrega": "Entrega en 15 días hábiles",
      "codigo": "TRP"
    }
  },
  "Maule": {
    "Cauquenes": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CQE"
    },
    "Chanco": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CNC"
    },
    "Colbún": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CLB"
    },
    "Constitución": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CTT"
    },
    "Curepto": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "CUR"
    },
    "Curicó": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CCO"
    },
    "Empedrado": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "EMP"
    },
    "Hualañé": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "HNE"
    },
    "Licantén": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "LCT"
    },
    "Linares": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LNR"
    },
    "Longaví": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LGV"
    },
    "Maule": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZMA"
    },
    "Molina": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZMO"
    },
    "Parral": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PRR"
    },
    "Pelarco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PLC"
    },
    "Pelluhue": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PEL"
    },
    "Pencahue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PEH"
    },
    "Rauco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RAU"
    },
    "Retiro": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RTR"
    },
    "Romeral": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RML"
    },
    "Río Claro": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RCL"
    },
    "Sagrada Familia": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SFA"
    },
    "San Clemente": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "STE"
    },
    "San Javier": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SJA"
    },
    "San Rafael": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SRF"
    },
    "Talca": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZCA"
    },
    "Teno": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "TEN"
    },
    "Vichuquén": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "VCH"
    },
    "Villa Alegre": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VGE"
    },
    "Yerbas Buenas": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "YBB"
    }
  },
  "O'Higgins": {
    "Chimbarongo": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CHB"
    },
    "Chépica": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CHE"
    },
    "Codegua": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZDE"
    },
    "Coinco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CNO"
    },
    "Coltauco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CTO"
    },
    "Doñihue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "DNE"
    },
    "Graneros": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "GRA"
    },
    "La Estrella": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "LAE"
    },
    "Las Cabras": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LCB"
    },
    "Litueche": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "LTU"
    },
    "Lolol": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "LOL"
    },
    "Machalí": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MCH"
    },
    "Malloa": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZML"
    },
    "Marchihue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "MRH"
    },
    "Mostazal": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SFM"
    },
    "Nancagua": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NGA"
    },
    "Navidad": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "NAV"
    },
    "Olivar": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "OAL"
    },
    "O’higgins": {
      "tiempo_entrega": "Entrega en 13 días hábiles",
      "codigo": "OHG"
    },
    "Palmilla": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PLA"
    },
    "Paredones": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PDS"
    },
    "Peralillo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZPE"
    },
    "Peumo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PEO"
    },
    "Pichidegua": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PHA"
    },
    "Pichilemu": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "PMU"
    },
    "Placilla": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PLL"
    },
    "Pumanque": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PMQ"
    },
    "Quinta de Tilcoco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QCC"
    },
    "Rancagua": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "RCG"
    },
    "Rengo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZRG"
    },
    "Requínoa": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "REQ"
    },
    "San Fernando": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SFR"
    },
    "San Vicente": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SVT"
    },
    "Santa Cruz": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ZSC"
    }
  },
  "Región Metropolitana": {
    "Alhué": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ALH"
    },
    "Buin": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "ZBU"
    },
    "Calera de Tango": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "CDT"
    },
    "Cerrillos": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "RRI"
    },
    "Cerro Navia": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "CNV"
    },
    "Colina": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "COL"
    },
    "Conchalí": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "CNH"
    },
    "Curacaví": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CVI"
    },
    "El Bosque": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "EBO"
    },
    "El Monte": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZTE"
    },
    "Estación Central": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "ECE"
    },
    "Huechuraba": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "HRB"
    },
    "Independencia": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "IDP"
    },
    "Isla de Maipo": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "IDM"
    },
    "La Florida": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LFD"
    },
    "La Granja": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LGJ"
    },
    "La Pintana": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LPT"
    },
    "La Reina": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LRN"
    },
    "Lampa": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LSG"
    },
    "Las Condes": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LCD"
    },
    "Lo Barnechea": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LBR"
    },
    "Lo Espejo": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LEP"
    },
    "Lo Prado": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "LPR"
    },
    "Macul": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "MAC"
    },
    "Maipú": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "MAI"
    },
    "María Pinto": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "MPO"
    },
    "Melipilla": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "ZMP"
    },
    "Padre Hurtado": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PHT"
    },
    "Paine": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "ZPN"
    },
    "Pedro Aguirre Cerda": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PAC"
    },
    "Peñaflor": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PFL"
    },
    "Peñalolén": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PNL"
    },
    "Pirque": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PIR"
    },
    "Providencia": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PRO"
    },
    "Pudahuel": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PUD"
    },
    "Puente Alto": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "PAL"
    },
    "Quilicura": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "QLC"
    },
    "Quinta Normal": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "QTN"
    },
    "Recoleta": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "RLT"
    },
    "Renca": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "REN"
    },
    "San Bernardo": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "SBD"
    },
    "San Joaquín": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "SJQ"
    },
    "San José de Maipo": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "SJS"
    },
    "San Miguel": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "SMG"
    },
    "San Pedro": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SPO"
    },
    "San Ramón": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "SRN"
    },
    "Talagante": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "TNT"
    },
    "Tiltil": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "TIL"
    },
    "Vitacura": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "VTC"
    },
    "Ñuñoa": {
      "tiempo_entrega": "Entrega en 1 días hábiles",
      "codigo": "NNA"
    }
  },
  "Tarapacá": {
    "Alto Hospicio": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "AHP"
    },
    "Camiña": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "CMN"
    },
    "Colchane": {
      "tiempo_entrega": "Entrega en 6 días hábiles",
      "codigo": "COE"
    },
    "Huara": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "HRA"
    },
    "Iquique": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "IQQ"
    },
    "Pica": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "OPC"
    },
    "Pozo Almonte": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "PAM"
    }
  },
  "Valparaíso": {
    "Algarrobo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ABO"
    },
    "Cabildo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CDO"
    },
    "Calera": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZLC"
    },
    "Calle Larga": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CLG"
    },
    "Cartagena": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CRT"
    },
    "Casablanca": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CBC"
    },
    "Catemu": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CAT"
    },
    "Concón": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "CON"
    },
    "El Quisco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "EQO"
    },
    "El Tabo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ETB"
    },
    "Hijuelas": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "HJS"
    },
    "Isla de Pascua": {
      "tiempo_entrega": "Entrega en 7 días hábiles",
      "codigo": "IPC"
    },
    "Juan Fernández": {
      "tiempo_entrega": "Entrega en 7 días hábiles",
      "codigo": "JFR"
    },
    "La Cruz": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "LCZ"
    },
    "La Ligua": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LLC"
    },
    "Limache": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LIC"
    },
    "Llaillay": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "LLY"
    },
    "Los Andes": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "LOB"
    },
    "Nogales": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NOG"
    },
    "Olmué": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "OLM"
    },
    "Panquehue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PNQ"
    },
    "Papudo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PPO"
    },
    "Petorca": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "PTK"
    },
    "Puchuncaví": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PCV"
    },
    "Putaendo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PUT"
    },
    "Quillota": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "QTA"
    },
    "Quilpué": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QPE"
    },
    "Quintero": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QTO"
    },
    "Rinconada": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "RDA"
    },
    "San Antonio": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SNT"
    },
    "San Esteban": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SEN"
    },
    "San Felipe": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SFP"
    },
    "Santa María": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SRI"
    },
    "Santo Domingo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SDC"
    },
    "Valparaíso": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "VAP"
    },
    "Villa Alemana": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "VIA"
    },
    "Viña del Mar": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "KNA"
    },
    "Zapallar": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZAR"
    }
  },
  "Ñuble": {
    "Bulnes": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "BLN"
    },
    "Chillán": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "YAI"
    },
    "Chillán Viejo": {
      "tiempo_entrega": "Entrega en 2 días hábiles",
      "codigo": "YAV"
    },
    "Cobquecura": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "CQU"
    },
    "Coelemu": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "ZOU"
    },
    "Coihueco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "CUH"
    },
    "El Carmen": {
      "tiempo_entrega": "Entrega en 5 días hábiles",
      "codigo": "YCX"
    },
    "Ninhue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NIN"
    },
    "Pemuco": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "ZPC"
    },
    "Pinto": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "PNO"
    },
    "Portezuelo": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "49H"
    },
    "Quillón": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QLL"
    },
    "Quirihue": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "QIH"
    },
    "Ranquil": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "RNQ"
    },
    "San Carlos": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SCS"
    },
    "San Fabián": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "SFB"
    },
    "San Ignacio": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SIG"
    },
    "San Nicolás": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "SNL"
    },
    "Treguaco": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "YTG"
    },
    "Yungay": {
      "tiempo_entrega": "Entrega en 4 días hábiles",
      "codigo": "YGY"
    },
    "Ñiquén": {
      "tiempo_entrega": "Entrega en 3 días hábiles",
      "codigo": "NYY"
    }
  }
};